// Brand Protection — Brand24-equivalent dashboard.
//
// Tab shell. Each tab is its own sub-component so individual files stay
// readable. Light theme; styling shared via brand-mentions.scss.
//
// Tabs (matching the Brand24 left sidebar):
//   Mentions          — paginated mention feed + chart + filters + side rail
//   Topic Analysis    — narrative_tag clusters with mentions/reach/SoV
//   Influencers       — sortable table (Brand24 PDF page 1 layout)
//   Comparison        — period-over-period delta metrics
//   AI Brand Assistant — chat UI + quick-start prompts (stub today)
//   Infographic       — single-page printable summary
//
// Sub-modules deliberately skipped vs Brand24:
//   AI Insights       — needs ML pipeline (separate session)
//   Demographics      — needs geo enrichment
//   Email / PDF / Excel reports — separate session
import React, { useState, useEffect } from 'react';
import MentionsTab     from './tabs/MentionsTab';
import TopicsTab       from './tabs/TopicsTab';
import InfluencersTab  from './tabs/InfluencersTab';
import AssistantTab    from './tabs/AssistantTab';
import InfographicTab  from './tabs/InfographicTab';
import DemographicsTab from './tabs/DemographicsTab';
import ThreatMonitorTab from './tabs/ThreatMonitorTab';
import SettingsTab      from './tabs/SettingsTab';
import { getUserFlags } from '../../helper';
import './brand-mentions.scss';

const ALL_TABS = [
    { key: 'mentions',        label: 'Mentions',              component: MentionsTab },
    { key: 'topics',          label: 'Topic Analysis',        component: TopicsTab },
    { key: 'demographics',    label: 'Demographics',          component: DemographicsTab },
    { key: 'influencers',     label: 'Influencers & Sources', component: InfluencersTab },
    { key: 'threat_monitor',  label: 'Threat Monitor',        component: ThreatMonitorTab },
    { key: 'assistant',       label: 'AI Brand Assistant',    component: AssistantTab },
    { key: 'infographic',     label: 'Infographic',           component: InfographicTab },
    { key: 'settings',        label: 'Settings',              component: SettingsTab },
];

function BrandMentions() {
    const flags = getUserFlags();
    const isAdmin = flags.is_org_admin === true || flags.is_platform_admin === true;
    const TABS = ALL_TABS.filter(t => {
        if (t.adminOnly) return isAdmin;
        return true;
    });
    const [tab, setTab] = useState('mentions');
    const Active = (TABS.find(t => t.key === tab) || TABS[0]).component;
    // Empty-state CTAs in child tabs dispatch this event to navigate
    // the user to e.g. the Settings tab (so they can configure watchlists
    // before findings populate).
    useEffect(() => {
        const handler = (e) => {
            const target = e?.detail?.tab;
            if (target && TABS.some(t => t.key === target)) setTab(target);
        };
        window.addEventListener('bm-tab-switch', handler);
        return () => window.removeEventListener('bm-tab-switch', handler);
    }, []);
    return (
        <div className="bm_root">
            <div className="bm_topbar">
                <h2 className="bm_title">Brand Protection</h2>
                <div className="bm_tabs">
                    {TABS.map(t => (
                        <button
                            key={t.key}
                            className={`bm_tab ${tab === t.key ? 'active' : ''}`}
                            onClick={() => setTab(t.key)}
                        >
                            {t.label}
                        </button>
                    ))}
                </div>
            </div>
            <div className="bm_tab_body">
                <Active />
            </div>
        </div>
    );
}

export default BrandMentions;
